import React from 'react';

import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useParams, useHistory } from 'react-router-dom';

import Loader from 'components/Loader';
import ManagePageHeader from 'components/ManagePageHeader/ManagePageHeader';
import actionLibraryInstancesApi from 'config/api/actionLibraryInstance/actionLibraryInstance';
import action_library_messages from 'messages/action_library_messages';
import ActionLibraryInstanceEditForm from 'pages/ActionLibraryInstance/ActionLibraryInstanceEditPage/ActionLibraryInstanceEditForm';
import PATHS from 'router/PATHS';

const ActionLibraryInstanceEditPage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const { data, isLoading } = useQuery(['actionLibraryInstance', id], () =>
    actionLibraryInstancesApi.getSingleActionLibraryInstance(Number(id)),
  );

  const handleBack = () => {
    history.push(PATHS.ACTION_LIBRARY_INSTANCE_DETAIL.replace(':id', id));
  };

  if (isLoading || !data) {
    return <Loader inner />;
  }

  return (
    <Container>
      <ManagePageHeader backButton onBack={handleBack} subtitle={t(action_library_messages.instance.edit_subtitle)}>
        {t(action_library_messages.instance.edit_title || action_library_messages.actions.edit)}
      </ManagePageHeader>
      <ActionLibraryInstanceEditForm instance={data.data} />
    </Container>
  );
};

export default ActionLibraryInstanceEditPage;
